module.exports = __webpack_public_path__ + "static/img/3_8_1.139ff66c.jpg";